import { useRouterState } from "@tanstack/react-router";
import { ClipboardCheck } from "lucide-react";

import { useOpenExtractionsSummary } from "../../api/ideation-maps.js";

import { useExtractionReview } from "./extraction-review-context.js";

/**
 * In-Atlas Review CTA while `/ideation` is active. Viewport-fixed top-right
 * overlays vault/CRM row actions and chat Extract (Product Lab intercepts).
 */
export function ExtractionReviewFloater() {
  const onIdeation = useRouterState({
    select: (s) => s.location.pathname.startsWith("/ideation"),
  });
  const summary = useOpenExtractionsSummary();
  const { openReview, isOpen } = useExtractionReview();
  const count = summary.data?.count ?? 0;

  if (!onIdeation || count === 0 || isOpen) return null;

  const mapCount = summary.data?.byMap.filter((b) => b.mapId).length ?? 0;
  const title =
    mapCount > 0
      ? `${count} open proposal${count === 1 ? "" : "s"} across ${mapCount} map${mapCount === 1 ? "" : "s"}`
      : `${count} open extraction${count === 1 ? "" : "s"} to review`;

  return (
    <button
      type="button"
      onClick={() => openReview()}
      title={title}
      aria-label={`Review ${count} pending extraction${count === 1 ? "" : "s"}`}
      className="fixed bottom-4 left-1/2 z-30 flex -translate-x-1/2 items-center gap-2 rounded-md border border-border bg-surface px-3 py-2 text-sm font-medium text-fg shadow-lg hover:bg-surface-muted"
    >
      <ClipboardCheck className="h-4 w-4 text-brand" aria-hidden="true" />
      <span>Review</span>
      <span className="inline-flex min-w-5 items-center justify-center rounded-sm bg-brand px-1.5 py-0.5 text-xs font-semibold text-brand-fg">
        {count}
      </span>
    </button>
  );
}
